import '../../scss/components/_btn-group.scss';

export type PaymentSourceType = 'CARD' | 'ACH' | 'CASH' | 'CHECK';

export interface PaymentSourceOption {
  key: PaymentSourceType;
  label: string;
}

export const MAIN_PAYMENT_OPTIONS: PaymentSourceOption[] = [
  { key: 'CARD', label: 'Card' },
  { key: 'ACH', label: 'ACH' },
  { key: 'CASH', label: 'Cash' },
  { key: 'CHECK', label: 'Check' },
];

export const RECURRING_PAYMENT_OPTIONS: PaymentSourceOption[] = [
  { key: 'CARD', label: 'Card' },
  { key: 'ACH', label: 'ACH' },
];

export interface PaymentSourceTabsProps {
  value: PaymentSourceType;
  onChange: (value: PaymentSourceType) => void;
  options?: PaymentSourceOption[];
  name?: string;
  minWidth?: number;
}

export const PaymentSourceTabs = ({
  value,
  onChange,
  options = MAIN_PAYMENT_OPTIONS,
  name = 'paymentSource',
  minWidth = 200,
}: PaymentSourceTabsProps) => {
  return (
    <div 
      className="buttongroup"
      test-id="payment-source-tabs"
      style={{ 
        borderRadius: '4px', 
        overflow: 'hidden', 
        display: 'flex', 
        width: 'auto', 
        minWidth: `${minWidth}px`, 
        height: '56px' 
      }}
    >
      {options.map((option) => (
        <span 
          key={option.key} 
          style={{ 
            flex: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            minWidth: 'fit-content',
          }}
        >
          <input
            id={`${name}-${option.key}`}
            type="radio"
            value={option.key}
            name={name}
            checked={value === option.key}
            onChange={() => onChange(option.key)}
            test-id={`payment-source-input-${option.key}`}
          />
          <label 
            htmlFor={`${name}-${option.key}`} 
            style={{ 
              width: '100%', 
              textAlign: 'center', 
              margin: 0, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              height: '100%', 
              whiteSpace: 'nowrap',
              padding: '0 12px',
            }}
          >
            {option.label}
          </label>
        </span>
      ))}
    </div>
  );
};

export default PaymentSourceTabs;
